import type { AppConfig } from '@type/AppConfig';
import { DizraptorEnvironment } from '@gql/types.generated';

export type Env = 'develop' | 'master';

const getSiteUrl = (env: Env | undefined): string => {
  switch (env) {
    case 'develop':
      return 'https://dizraptor.work';
    case 'master':
      return 'https://dizraptor.app';
    default:
      return 'http://localhost';
  }
};

export function getConfig(env?: Env): AppConfig {
  const domain = env === 'master' ? 'app' : 'work';

  return {
    env: env === 'master' ? DizraptorEnvironment.Prod : DizraptorEnvironment.Test,
    isDevelop: env === undefined,
    appleAuth: {
      clientId: env === 'master' ? 'app.dizraptor.auth.client' : 'work.dizraptor.auth.client',
      returnUrl:
        env === 'master' ? 'https://dizraptor.app/returnUrl' : 'https://dizraptor.work/returnUrl'
    },
    googleAuth: {
      clientId:
        env === 'master'
          ? '612659843529-0fm4m8aglae6rvfug18hhdmm80m33tv0.apps.googleusercontent.com'
          : '612659843529-pd6mnq0hibbje7f17d28c8bqhapvrvlp.apps.googleusercontent.com'
    },
    featureFlags:
      env === 'master'
        ? {
            useDocusign: true
          }
        : {
            useDocusign: true
          },
    sessionService: {
      clientId: 'utcom',
      realm: 'aurora'
    },
    dizraptorGateway: {
      rest: {
        url: {
          protocol: 'https',
          hostname: `dizraptor-gateway-backend.dizraptor.${domain}`
        }
      },
      stream: {
        url: {
          protocol: 'wss',
          hostname: `dizraptor-gateway-backend.dizraptor.${domain}`,
          pathname: '/ws'
        },
        heartbeatInterval: 2000
      }
    },
    sentryDSN: env === 'master' ? '' : '',
    googleTagManager: env === 'master' ? 'GTM-KVZR42Q' : 'GTM-N5ZZZPC',
    siteUrl: getSiteUrl(env),
    visitCollectorUrl: `https://visit-collector.dizraptor.${domain}/api/v1/visits`,
    gqlGatewayUrl: `https://dizraptor-graphql-gateway.dizraptor.${domain}/graphql`
  };
}
